module.exports = __webpack_public_path__ + "static/hashtagcoder-icon-5a90049f017933546ce12a9e490c4c02.png";